<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_ic">Contents</a></h1><a id="page_ic">
</a><h2 class="toc-chap"><a id="page_ic"></a><a href="#/xhtml/02_Argument">Argument</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/03_Chapter01">Dramatis Personæ</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/04_Chapter02">Oedipus Rex</a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?673850cf